import ApplicationController from './application_controller'

// This controller takes an Array of item targets and filters them by:
//	  - parsing a JSON object stored in each item's data-item-attributes='{}'
//	  - matching filterInput targets by using data-filter-attribute-name the input value against the item's data-item-attributes
//	for matches it will:
//	  - remove d-none
//	  - remove the disabled attribute on all Input elements
//	and the opposite for failed matches.
export default class extends ApplicationController {

	static targets = [
		'item',
		'filterInput'
	]

	connect() {
		if (this.filterInputTargets.some(input => input.value)) {
			this.filterItems()
		}
	}

	filterItems(_event) {
		const filters = this.filterInputTargets
		.filter((input) => {
			switch(input.type) {
				case 'radio':
					if (input.checked) { return true }
					break
				case 'checkbox':
					if (input.checked) { return true }
					break
				default:
					return true
			}
			return false
		})
		.map((input) => {
			return { attributeName: input.dataset.filterAttributeName, attributeValue: input.value }
		})

		this.itemTargets.forEach((item) => {
			if (this.filtersMatchItem(filters, item)) {
				item.classList.remove('d-none')
				this.enableInputs(item)
			} else {
				item.classList.add('d-none')
				this.disableInputs(item)
			}
		})
	}

	filtersMatchItem(filters, item) {
		const attributes = JSON.parse(item.dataset.itemAttributes)

		//console.log(`filters: ${JSON.stringify(filters)}`)
		//console.log(`itemAttributes: ${JSON.stringify(attributes)}`)

		return filters.every((filter) => {
			const value = attributes[filter.attributeName]

			if (value instanceof Array) {
				return value.some(v => v == filter.attributeValue)
			} else {
				return value == filter.attributeValue
			}
		})
	}

	enableInputs(itemElement) {
		Array.from(itemElement.querySelectorAll('input, select'))
			.forEach(inputElement => inputElement.disabled = false)
	}

	disableInputs(itemElement) {
		Array.from(itemElement.querySelectorAll('input, select'))
			.forEach(inputElement => inputElement.disabled = true)

	}

}
